<template>
  <span class="navigation-menu fill-height">
    <div>
    <div class="d-flex logo">
      <logo></logo>
    </div>
    <div class="d-flex flex-wrap sections">
      <router-link to="/interventions" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : $route.name === 'Interventions'}]">
        <navigation-icon-svg type="interventions" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Interventions</span>
      </router-link>
      <router-link to="/enquetes" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : ['Enquetes', 'EnquetesNew', 'EnquetesResultat', 'EnquetesResultatDetail'].includes($route.name)}]">
        <navigation-icon-svg type="enquetes" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Enquêtes</span>
      </router-link>
      <router-link to="/locataires" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : $route.name === 'Locataires'}]">
        <navigation-icon-svg type="locataires" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Locataires</span>
      </router-link>
      <router-link to="/gestion-points/loterie" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : ['GestionPointsLoterie', 'GestionPointsLoterieNew', 'GestionPointsCatalogue', 'GestionPointsCatalogueNew'].includes($route.name)}]">
        <navigation-icon-svg type="gestion-points" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Gestion des points</span>
      </router-link>
      <router-link to="/comptes" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : ['Comptes', 'ComptesNew'].includes($route.name)}]">
        <navigation-icon-svg type="comptes" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Comptes</span>
      </router-link>
      <router-link to="/action-collaborative" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : ['ActionCollaborative', 'ActionCollaborativeNew'].includes($route.name)}]">
        <navigation-icon-svg type="action-collaborative" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Action collaborative</span>
      </router-link>
      <router-link to="/annuaire" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : $route.name === 'Annuaire'}]">
        <navigation-icon-svg type="annuaire" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Annuaire</span>
      </router-link>
      <router-link to="/annonces" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : $route.name === 'Annonces'}]">
        <navigation-icon-svg type="annonces" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Annonces</span>
      </router-link>
      <router-link to="/baux" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : $route.name === 'Baux'}]">
        <navigation-icon-svg type="baux" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Baux</span>
      </router-link>
      <router-link to="/operations" :class="['d-flex flex-column cursor-pointer text-decoration-none sections-element',{active : ['Operations', 'OperationsNew'].includes($route.name)}]">
        <navigation-icon-svg type="operations" class="mx-auto section-icon"></navigation-icon-svg>
        <span class="text-center section-title">Opérations</span>
      </router-link>
      <router-link to="/" :class="['d-flex text-decoration-none dashboard',{active : $route.name === 'Home'}]">
        <div class="d-flex mx-auto py-2">
          <span>Dashboard</span>
        </div>
      </router-link>
    </div>
    </div>
  </span>
</template>

<script>
import logo from './Logo.vue'
import navigationIconSvg from './NavigationIconSvg.vue'
export default {
  name: 'NavigationMenu',
  components: { logo, navigationIconSvg },
  data: () => ({})
}
</script>

<style lang="scss">
  .navigation-menu{
    background-color: #F9F9F9;
    padding-top: 2rem;
    .sections{
      padding: 2rem 2rem 5rem;
      @include bigScreen{
        padding: 2rem 3rem 5rem;
      }
      .sections-element{
        padding: 0.5rem;
        width: 50%;
        transition: all 0.3s ease-in-out;
        @include bigScreen{
          padding: 1rem 0.5rem;
        }
        .section-icon{
          background-color: $bg-icons;
          border-radius: 10px;
          padding: 0.5em;
        }
        .section-title{
          color: $icon-title;
          font-size: 0.7rem;
          @include bigScreen{
            font-size: 0.9rem;
          }
        }
        &:hover, &.active{
          .section-icon{
            background-color: $primary;
            .section-icon-color{
              fill: white;
            }
          }
          .section-title{
            color: $icon-title-active;
          }
        }
      }
    }
    .dashboard{
      position: absolute;
      display: block;
      left: 0;
      bottom: 0;
      width: 20vw;
      background-color: $icon-title;
      transition: all 0.3s ease-in-out;
      @include bigScreen{
        padding: 0.5rem 0;
      }
      span{
        color: white;
        font-size: 1rem;
        @include bigScreen{
          font-size: 1.2rem;
        }
      }
      &:hover, &.active{
        background-color: $primary;
      }
    }
    @include bigScreen{
      position: fixed;
      min-height: 100vh;
      width: 20vw;
      top: 0;
      left: 0;
      padding-top: 2rem;
    }
  }
</style>